import { cva } from '@/styled-system/css';

export const selectRecipe = cva({
  base: {
    appearance: 'none',
    paddingInlineEnd: '{sizes.Select.icon}',
  },
  variants: {
    fluid: {
      true: {},
      false: {
        width: 'auto',
      },
    },
    readOnly: {
      true: {},
      false: {
        backgroundImage: {
          // have to do this because the browser doesn't resolve CSS variables inside SVGs embedded as data URIs.
          base: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%2354545A' fill-rule='evenodd' d='M14.7 5.3a1 1 0 0 0-1.4 0L8 10.6 2.7 5.3a1 1 0 1 0-1.4 1.4l6 6a1 1 0 0 0 1.4 0l6-6a1 1 0 0 0 0-1.4Z' clip-rule='evenodd'/%3E%3C/svg%3E")`,
          _dark: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%23A7A6AB' fill-rule='evenodd' d='M14.7 5.3a1 1 0 0 0-1.4 0L8 10.6 2.7 5.3a1 1 0 1 0-1.4 1.4l6 6a1 1 0 0 0 1.4 0l6-6a1 1 0 0 0 0-1.4Z' clip-rule='evenodd'/%3E%3C/svg%3E")`,
        },
        backgroundSize: '16px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 20px center',
      },
    },
    disabled: {
      true: {
        cursor: 'default',
      },
      false: {
        cursor: 'pointer',
      },
    },
  },
});
